/* eslint-disable import/prefer-default-export */
import { createCoa, checkRes, timeout, retry, jsonp, RequestLogicError } from '@tencent/Coa';

function request() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    jsonp: false
  };
  var filters = [];

  if (options.retry) {
    filters.push(retry(options.retry));
  }

  filters.push(timeout(options.timeout || 5000));

  if (typeof options.checkRes === 'function') {
    filters.push(options.checkRes);
  } else {
    filters.push(checkRes(function (res) {
      if ('ret' in res && res.ret !== 0 || res.result && res.result.code !== 0) {
        var code = res.ret || res.result && res.result.code;
        var msg = res.msg || res.result && res.result.msg;
        throw new RequestLogicError(msg, code, res);
      }

      return res;
    }));
  }

  if (options.jsonp) {
    filters.push(jsonp());
  }

  return createCoa(filters);
}

export { request };